import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=0b80ec6a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b80ec6a')) {
      api.createRecord('0b80ec6a', component.options)
    } else {
      api.reload('0b80ec6a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=0b80ec6a&", function () {
      api.rerender('0b80ec6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h5g0CW0B5BR2/JS/comp/ImgFallback.vue"
export default component.exports